import { HelpClientProvider } from '@commerce-os/help-client';
import { HELP_FALLBACKS } from 'virtual:help-client/fallbacks';
import AppRoutes from './routes';
import { TelemetryProvider } from './telemetry';
import { getApiClient } from './lib/axios';

function App() {
  // Phase 34.3b — wraps the routed tree so the singleton TelemetryClient
  // is available via `useTrack()` everywhere + the route-change listener
  // auto-fires page-views on every navigation.
  //
  // Phase 35.3a — wraps the routed tree so every help-client hook
  // (`useTooltip`, `useHelpArticle`, `useHelpArticleList`, etc.) sees a
  // configured transport singleton at first render. The provider is
  // optional sugar over `setHelpTransport(getApiClient())` — wrapping it
  // here means the dashboard's REST + auth + 401-refresh interceptor
  // chain is reused verbatim, no separate axios instance for help.
  //
  // Phase 35.3c — `HELP_FALLBACKS` arrives via the
  // `mdxFallbackVitePlugin` virtual module (`vite.config.ts`). The
  // plugin scans `docs/help/tooltips/*.mdx` at build start + bakes the
  // typed array into the bundle. Threading it into the provider's
  // `fallbacks` prop populates the runtime tooltip registry before the
  // first render — `<HelpTooltip>` renders the in-repo body when
  // `useTooltip` short-circuits on a CMS outage / opaque-404, so a
  // merchant always sees something useful even when the CMS is down.
  return (
    <HelpClientProvider transport={getApiClient()} fallbacks={HELP_FALLBACKS}>
      <TelemetryProvider>
        <AppRoutes />
      </TelemetryProvider>
    </HelpClientProvider>
  );
}

export default App;
